<!-- Contributor Table with Employer-style Bootstrap Classes -->
<div class="mt-4 mx-4">

  <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>

  <div class="card shadow-sm border-0">
    <div class="card-body">
      <div class="row align-items-center mb-3 mt-3">
        <!-- Search -->
        <div class="col-md-9 col-sm-12 mb-2 mb-md-0">
          <div class="position-relative">
            <input id="searchContributor" type="text" class="form-control employer-search-input shadow-none"
              placeholder="Type here..." [ngModel]="searchText()" (ngModelChange)="onSearchChange($event)" />
            <span class="search-icon" (click)="onSearchChange(searchText())">
              <i class="bi bi-search"></i>
            </span>
          </div>
        </div>
        <div class="col-md-3 col-sm-12 text-md-end text-start mt-3 mt-md-0">
          <button class="btn add-user-btn w-md-auto w-100" type="button" data-bs-toggle="offcanvas"
            *ngIf="authService.canAdd('fundManagement.contributorManagement')" data-bs-target="#contributorOffcanvas"
            aria-controls="contributorOffcanvas" (click)="openAddContributorForm()">
            <i class="bi bi-person-plus me-2"></i>
            Add Contributor
          </button>
        </div>
      </div>

      <!-- Empty State -->
      <div *ngIf="filteredContributors().length === 0" class="text-center py-5">
        <i class="bi bi-inbox fs-1 text-muted mb-3"></i>
        <p class="text-muted">No Contributors Found.</p>
      </div>

      <!-- Table -->
      <div *ngIf="filteredContributors().length > 0" class="table-responsive-wrapper">
        <table class="table table-striped">
          <thead>
            <tr>
              <th class="table-title text-start">Contributor Name</th>
              <th class="table-title text-start">Email</th>
              <th class="table-title text-start">Phone Number</th>
              <th class="table-title text-start">Country</th>
              <th class="table-title text-end">Contributed Amount</th>
              <th class="table-title text-center">Cost of Funds</th>
              <th class="table-title text-center">
                <i class="bi bi-eye"></i>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let contributor of pagedContributors">
              <td class="table-data-text text-start" data-label="Contributor Name">{{ contributor.name }}</td>
              <td class="table-data-text text-start" data-label="Email">{{ contributor.email }}</td>
              <td class="table-data-text text-start" data-label="Phone Number">{{ contributor.phoneNumber }}</td>
              <td class="table-data-text text-start" data-label="Country">{{ contributor.country }}</td>
              <td class="table-data-text text-end" data-label="Contributed Amount">
                {{ contributor.currency }} {{ contributor.contributionAmount | number:'1.2-2' }}
              </td>
              <td class="table-data-text text-center" data-label="Cost of Funds">{{ contributor.costOfFunds }}%</td>
              <td class="table-data-text text-center" data-label="Actions">
                <button class="btn p-0" style="background: none; border: none;" type="button" data-bs-toggle="offcanvas"
                  data-bs-target="#contributorOffcanvas" aria-controls="contributorOffcanvas"
                  (click)="openViewContributorForm(contributor)">
                  <i class="bi bi-arrow-right" style="color: var(--primary-color); font-size: 1.2rem;"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- Pagination toolbar -->
        <app-paginator [dataSource]="filteredContributors()" [pageSize]="10" [pageSizeOptions]="[5, 10, 20, 50]"
          (pageChange)="onContributorsPageChange($event)">
        </app-paginator>
      </div>
    </div>
  </div>
</div>

<!-- Contributor Form Offcanvas -->
<div #contributorOffcanvasEl class="offcanvas offcanvas-end w-80" tabindex="-1" id="contributorOffcanvas"
  aria-labelledby="contributorOffcanvasLabel" data-bs-backdrop="static" data-bs-keyboard="false">

  <div class="offcanvas-header">
    <div class="container-fluid">
      <div class="row align-items-center">
        <div class="col-10 d-flex align-items-center">
          <h5 class="offcanvas-title d-flex align-items-center gap-2 mb-0" id="contributorOffcanvasLabel">
            <i class="bi fs-5"
              [ngClass]="mode() === 'add' ? 'bi-person-plus' : mode() === 'edit' ? 'bi-pencil-square' : 'bi-person'"></i>
            {{ mode() === 'add' ? 'Add Contributor' : mode() === 'edit' ? 'Edit Contributor' : 'Contributor Details' }}
          </h5>
        </div>
        <div class="col-2 text-end">
          <button class="btn-close text-reset" type="button" data-bs-dismiss="offcanvas" aria-label="Close"
            (click)="clearForm()"></button>
        </div>
      </div>
    </div>
  </div>

  <div class="offcanvas-body">

    <form [formGroup]="contributorForm">
      <div class="contributor-type-selector d-flex gap-4 mb-4">
        <label class="form-check form-check-inline">
          <input class="form-check-input" type="radio" value="individual" formControlName="contributorType"
            [disabled]="mode() === 'edit'" (change)="onContributorTypeChange('individual')" />
          <span class="form-check-label">Individual</span>
        </label>

        <label class="form-check form-check-inline">
          <input class="form-check-input" type="radio" value="company" formControlName="contributorType"
            [disabled]="mode() === 'edit'" (change)="onContributorTypeChange('company')" />
          <span class="form-check-label">Company</span>
        </label>
      </div>


      <div class="row g-4">
        @if (getContributorType() === 'individual') {
        <div class="col-lg-12 form-section border-start-lg" formGroupName="individual"
          [class.form-section-disabled]="!isSectionActive('individual')">
          <div class="section-heading">Individual</div>
          <div class="row g-3">
            <div class="col-12 col-lg-6">
              <div class="form-group-fixed">
                <label class="label-text">Full Name <span class="text-danger">*</span></label>
                <input type="text" appInputLimit class="form-control rounded-pill shadow-none input-text"
                  placeholder="Type here" formControlName="fullName"
                  [class.is-invalid]="contributorForm.get('individual.fullName')?.invalid && contributorForm.get('individual.fullName')?.touched" />
                <div class="invalid-feedback">
                  <div *ngIf="contributorForm.get('individual.fullName')?.errors?.['required']">
                    Full name is required.
                  </div>
                  <div *ngIf="contributorForm.get('individual.fullName')?.errors?.['pattern']">
                    Please enter a valid name format.
                  </div>
                  <div *ngIf="contributorForm.get('individual.fullName')?.errors?.['maxlength']">
                    Full name cannot exceed {{
                    contributorForm.get('individual.fullName')?.errors?.['maxlength'].requiredLength}} characters.
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div class="form-group-fixed">
                <label class="label-text">NIC <span class="text-danger">*</span></label>
                <input type="text" appInputLimit class="form-control rounded-pill shadow-none input-text"
                  placeholder="Type here" formControlName="nic"
                  [class.is-invalid]="contributorForm.get('individual.nic')?.invalid && contributorForm.get('individual.nic')?.touched" />
                <div class="invalid-feedback">
                  <div *ngIf="contributorForm.get('individual.nic')?.errors?.['required']">
                    NIC is required.
                  </div>
                  <div *ngIf="contributorForm.get('individual.nic')?.errors?.['pattern']" class="text-wrap mt-3">
                    Please enter a valid NIC number.
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div class="form-group-fixed">
                <label class="label-text">Gender <span class="text-danger">*</span></label>
                <div class="input-group">
                  <select class="form-control shadow-none input-text select-with-icon" formControlName="gender"
                    [class.is-invalid]="contributorForm.get('individual.gender')?.invalid && contributorForm.get('individual.gender')?.touched">
                    <option value="" disabled>Select a Gender</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="other">Other</option>
                  </select>
                  <span class="input-group-text"><i class="bi bi-chevron-down"></i></span>
                </div>
                <div class="invalid-feedback d-block"
                  *ngIf="contributorForm.get('individual.gender')?.invalid && contributorForm.get('individual.gender')?.touched">
                  <div *ngIf="contributorForm.get('individual.gender')?.errors?.['required']">
                    Gender is required.
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div class="form-group-fixed">
                <label class="label-text">Date of Birth <span class="text-danger">*</span></label>
                <input type="date" class="form-control rounded-pill shadow-none input-pill" placeholder="yyyy-mm-dd"
                  formControlName="dob"
                  [class.is-invalid]="contributorForm.get('individual.dob')?.invalid && contributorForm.get('individual.dob')?.touched" />
                <div class="invalid-feedback">
                  <div *ngIf="contributorForm.get('individual.dob')?.errors?.['required']">
                    Date of birth is required.
                  </div>

                  <div *ngIf="contributorForm.get('individual.dob')?.errors?.['underAge']">
                    You must be at least 18 years old.
                  </div>

                  <div *ngIf="contributorForm.get('individual.dob')?.errors?.['invalidDate']">
                    Invalid date format.
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div class="form-group-fixed">
                <label class="label-text">Email <span class="text-danger">*</span></label>
                <input type="email" appInputLimit class="form-control rounded-pill shadow-none input-text"
                  placeholder="Type here" formControlName="email"
                  [class.is-invalid]="contributorForm.get('individual.email')?.invalid && contributorForm.get('individual.email')?.touched" />
                <div class="invalid-feedback">
                  <div *ngIf="contributorForm.get('individual.email')?.errors?.['required']">
                    Email is required.
                  </div>
                  <div *ngIf="contributorForm.get('individual.email')?.errors?.['pattern']">
                    Please enter a valid email address.
                  </div>
                  <div *ngIf="contributorForm.get('individual.email')?.errors?.['maxlength']">
                    Email cannot exceed {{
                    contributorForm.get('individual.email')?.errors?.['maxlength'].requiredLength}} characters.
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div class="form-group-fixed">
                <label class="label-text">Mobile Number <span class="text-danger">*</span></label>
                <input type="text" appInputLimit class="form-control rounded-pill shadow-none input-text"
                  placeholder="Type here" formControlName="mobileNumber"
                  [class.is-invalid]="contributorForm.get('individual.mobileNumber')?.invalid && contributorForm.get('individual.mobileNumber')?.touched" />
                <div class="invalid-feedback">
                  <div *ngIf="contributorForm.get('individual.mobileNumber')?.errors?.['required']">
                    Mobile number is required.
                  </div>
                  <div *ngIf="contributorForm.get('individual.mobileNumber')?.errors?.['pattern']">
                    Please enter a valid mobile number.
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div class="form-group-fixed">
                <label class="label-text">Country <span class="text-danger">*</span></label>
                <input type="text" appInputLimit class="form-control rounded-pill shadow-none input-text"
                  placeholder="Type here" formControlName="country"
                  [class.is-invalid]="contributorForm.get('individual.country')?.invalid && contributorForm.get('individual.country')?.touched" />
                <div class="invalid-feedback">
                  <div *ngIf="contributorForm.get('individual.country')?.errors?.['required']">
                    Country is required.
                  </div>
                  <div *ngIf="contributorForm.get('individual.country')?.errors?.['maxlength']">
                    Country cannot exceed {{
                    contributorForm.get('individual.country')?.errors?.['maxlength'].requiredLength}} characters.
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div class="form-group-fixed">
                <label class="label-text">City <span class="text-danger">*</span></label>
                <input type="text" appInputLimit class="form-control rounded-pill shadow-none input-text"
                  placeholder="Type here" formControlName="city"
                  [class.is-invalid]="contributorForm.get('individual.city')?.invalid && contributorForm.get('individual.city')?.touched" />
                <div class="invalid-feedback">
                  <div *ngIf="contributorForm.get('individual.city')?.errors?.['required']">
                    City is required.
                  </div>
                  <div *ngIf="contributorForm.get('individual.city')?.errors?.['maxlength']">
                    City cannot exceed {{ contributorForm.get('individual.city')?.errors?.['maxlength'].requiredLength}}
                    characters.
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="form-group-fixed">
                <label class="label-text">Address <span class="text-danger">*</span></label>
                <input type="text" appInputLimit class="form-control rounded-pill shadow-none input-text"
                  placeholder="Type here" formControlName="address"
                  [class.is-invalid]="contributorForm.get('individual.address')?.invalid && contributorForm.get('individual.address')?.touched" />
                <div class="invalid-feedback">
                  <div *ngIf="contributorForm.get('individual.address')?.errors?.['required']">
                    Address is required.
                  </div>
                  <div *ngIf="contributorForm.get('individual.address')?.errors?.['maxlength']">
                    Address cannot exceed {{
                    contributorForm.get('individual.address')?.errors?.['maxlength'].requiredLength}} characters.
                  </div>
                </div>
              </div>
            </div>
          </div>

          <h6 class="text-muted mt-4">Bank Account</h6>
          <hr class="my-3" />

          <div class="row g-3">
            <div class="col-12 col-lg-6">
              <div class="form-group-fixed">
                <label class="label-text">Account Holder Name <span class="text-danger">*</span></label>
                <input type="text" appInputLimit class="form-control rounded-pill shadow-none input-text"
                  placeholder="Type here" formControlName="accountHolderName"
                  [class.is-invalid]="contributorForm.get('individual.accountHolderName')?.invalid && contributorForm.get('individual.accountHolderName')?.touched" />
                <div class="invalid-feedback">
                  <div *ngIf="contributorForm.get('individual.accountHolderName')?.errors?.['required']">
                    Account holder name is required.
                  </div>
                  <div *ngIf="contributorForm.get('individual.accountHolderName')?.errors?.['pattern']">
                    Please enter a valid account holder name.
                  </div>
                  <div *ngIf="contributorForm.get('individual.accountHolderName')?.errors?.['maxlength']">
                    Account holder name cannot exceed {{
                    contributorForm.get('individual.accountHolderName')?.errors?.['maxlength'].requiredLength}}
                    characters.
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-lg-6">
              <div class="form-group-fixed">
                <label class="label-text">Bank <span class="text-danger">*</span></label>

                <!-- Custom Searchable Dropdown -->
                <div class="searchable-dropdown"
                  [class.is-invalid]="contributorForm.get('individual.bankId')?.invalid && contributorForm.get('individual.bankId')?.touched"
                  [class.disabled]="!!contributorForm.get('individual.bankId')?.disabled">

                  <!-- Hidden input to hold the actual bankId for Reactive Forms -->
                  <input type="hidden" formControlName="bankId">

                  <!-- Visible Search Input (NO formControlName here!) -->
                  <div class="dropdown-input-wrapper">
                    <input type="text" class="form-control shadow-none input-text" [value]="getSelectedBankName()"
                      (input)="onFilterBankSearchChange($event)" (focus)="openDropdown()" (blur)="onBlur()"
                      placeholder="Select a Bank" autocomplete="off"
                      [disabled]="contributorForm.get('individual.bankId')?.disabled" #searchInput>
                    <span class="input-group-text"><i class="bi bi-chevron-down"></i></span>
                  </div>

                  <!-- Dropdown Options List -->
                  <div class="dropdown-list"
                    *ngIf="dropdownOpen && filteredBanks().length > 0 && !contributorForm.get('individual.bankId')?.disabled">
                    <div class="dropdown-item" *ngFor="let bank of filteredBanks()" (mousedown)="selectBank(bank)"
                      [class.selected]="contributorForm.get('individual.bankId')?.value === bank.bankId">
                      <span class="bank-name">{{ bank.bankName }}</span>
                    </div>
                  </div>

                  <!-- No Results Message -->
                  <div class="dropdown-list no-results"
                    *ngIf="dropdownOpen && filteredBanks().length === 0 && !contributorForm.get('individual.bankId')?.disabled">
                    <div class="dropdown-item">No banks found</div>
                  </div>
                </div>

                <div class="invalid-feedback d-block"
                  *ngIf="contributorForm.get('individual.bankId')?.invalid && contributorForm.get('individual.bankId')?.touched">
                  <div *ngIf="contributorForm.get('individual.bankId')?.errors?.['required']">
                    Bank is required.
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-lg-6">
              <div class="form-group-fixed">
                <label class="label-text">Account Number <span class="text-danger">*</span></label>
                <input type="text" appInputLimit class="form-control rounded-pill shadow-none input-text"
                  placeholder="Type here" formControlName="accountNumber"
                  [class.is-invalid]="contributorForm.get('individual.accountNumber')?.invalid && contributorForm.get('individual.accountNumber')?.touched" />
                <div class="invalid-feedback">
                  <div *ngIf="contributorForm.get('individual.accountNumber')?.errors?.['required']">
                    Account number is required.
                  </div>
                  <div *ngIf="contributorForm.get('individual.accountNumber')?.errors?.['pattern']">
                    Please enter a valid account number.
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div class="form-group-fixed">
                <label class="label-text">Contribution Amount <span class="text-danger">*</span></label>
                <app-formatted-number-input [min]="0" [max]="999999999999.99"
                  formControlName="contributionAmount" [isInvalid]="!!(contributorForm.get('individual.contributionAmount')?.invalid && contributorForm.get('individual.contributionAmount')?.touched)"
                  class="formatted-input-control" />
                <!-- <input type="number" appInputLimit min="0" max="999999999999.99" step="0.01" class="form-control rounded-pill shadow-none input-text"
                  placeholder="Type here" formControlName="contributionAmount"
                  [class.is-invalid]="contributorForm.get('individual.contributionAmount')?.invalid && contributorForm.get('individual.contributionAmount')?.touched" /> -->
                <div class="invalid-feedback">
                  <div *ngIf="contributorForm.get('individual.contributionAmount')?.errors?.['required']">
                    Contribution amount is required.
                  </div>
                  <div *ngIf="contributorForm.get('individual.contributionAmount')?.errors?.['min']">
                    Contribution amount cannot be negative.
                  </div>
                  <div *ngIf="contributorForm.get('individual.contributionAmount')?.errors?.['max']">
                    Contribution amount cannot exceed the maximum allowed value - 999999999999.99.
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div class="form-group-fixed">
                <label class="label-text">Currency <span class="text-danger">*</span></label>
                <div class="input-group">
                  <select class="form-control shadow-none input-text select-with-icon" formControlName="currency"
                    [class.is-invalid]="contributorForm.get('individual.currency')?.invalid && contributorForm.get('individual.currency')?.touched">
                    <option [ngValue]="null" disabled>Select a Currency</option>
                    <option *ngFor="let currency of currencies()" [ngValue]="currency.currencyId">
                      {{ currency.isoCode }} - {{ currency.name }}
                    </option>
                  </select>
                  <span class="input-group-text"><i class="bi bi-chevron-down"></i></span>
                </div>
                <div class="invalid-feedback d-block"
                  *ngIf="contributorForm.get('individual.currency')?.invalid && contributorForm.get('individual.currency')?.touched">
                  <div *ngIf="contributorForm.get('individual.currency')?.errors?.['required']">
                    Currency is required.
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div class="form-group-fixed">
                <label class="label-text">Cost of Fund <span class="text-danger">*</span></label>
                <div class="input-group">
                  <input type="number" appInputLimit min="0" max="100" step="0.01"
                    class="form-control cost-of-fund shadow-none input-text" placeholder="Type here"
                    formControlName="costOfFund"
                    [class.is-invalid]="contributorForm.get('individual.costOfFund')?.invalid && contributorForm.get('individual.costOfFund')?.touched" />
                  <span class="input-group-text">%</span>
                </div>
                <div class="invalid-feedback d-block"
                  *ngIf="contributorForm.get('individual.costOfFund')?.invalid && contributorForm.get('individual.costOfFund')?.touched">
                  <div *ngIf="contributorForm.get('individual.costOfFund')?.errors?.['required']">
                    Cost of fund is required.
                  </div>
                  <div
                    *ngIf="contributorForm.get('individual.costOfFund')?.errors?.['min'] || contributorForm.get('individual.costOfFund')?.errors?.['max']">
                    Cost of fund must be between 0 and 100.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        }

        @if (getContributorType() === 'company') {
        <div class="col-lg-12 form-section border-start-lg" formGroupName="company"
          [class.form-section-disabled]="!isSectionActive('company')">
          <div class="section-heading">Company</div>
          <div class="row g-3">
            <div class="col-12 col-lg-6">
              <div class="form-group-fixed">
                <label class="label-text">Company Name <span class="text-danger">*</span></label>
                <input type="text" appInputLimit class="form-control rounded-pill shadow-none input-text"
                  placeholder="Type here" formControlName="companyName"
                  [class.is-invalid]="contributorForm.get('company.companyName')?.invalid && contributorForm.get('company.companyName')?.touched" />
                <div class="invalid-feedback">
                  <div *ngIf="contributorForm.get('company.companyName')?.errors?.['required']">
                    Company name is required.
                  </div>
                  <div *ngIf="contributorForm.get('company.companyName')?.errors?.['pattern']">
                    Please enter a valid name format.
                  </div>
                  <div *ngIf="contributorForm.get('company.companyName')?.errors?.['maxlength']">
                    Company name cannot exceed {{
                    contributorForm.get('company.companyName')?.errors?.['maxlength'].requiredLength}} characters.
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div class="form-group-fixed">
                <label class="label-text">VAT Number / Tax ID <span class="text-danger">*</span></label>
                <input type="text" appInputLimit class="form-control rounded-pill shadow-none input-text"
                  placeholder="Type here" formControlName="vatNumber"
                  [class.is-invalid]="contributorForm.get('company.vatNumber')?.invalid && contributorForm.get('company.vatNumber')?.touched" />
                <div class="invalid-feedback">
                  <div *ngIf="contributorForm.get('company.vatNumber')?.errors?.['required']">
                    VAT number / Tax ID is required.
                  </div>
                  <div *ngIf="contributorForm.get('company.vatNumber')?.errors?.['pattern']">
                    Please enter a valid VAT number / Tax ID.
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div class="form-group-fixed">
                <label class="label-text">Industry <span class="text-danger">*</span></label>
                <div class="input-group">
                  <select class="form-control shadow-none input-text select-with-icon" formControlName="industryId"
                    [class.is-invalid]="contributorForm.get('company.industryId')?.invalid && contributorForm.get('company.industryId')?.touched">
                    <option [ngValue]="null" disabled>Select a Industry</option>
                    <option *ngFor="let industry of industries" [value]="industry.industryTypeId">
                      {{ industry.industryDescription }}
                    </option>
                  </select>
                  <span class="input-group-text"><i class="bi bi-chevron-down"></i></span>
                </div>
                <div class="invalid-feedback d-block"
                  *ngIf="contributorForm.get('company.industryId')?.invalid && contributorForm.get('company.industryId')?.touched">
                  <div *ngIf="contributorForm.get('company.industryId')?.errors?.['required']">
                    Industry is required.
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div class="form-group-fixed">
                <label class="label-text">Company Website</label>
                <input type="text" class="form-control rounded-pill shadow-none input-text" placeholder="https://"
                  formControlName="website" />
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div class="form-group-fixed">
                <label class="label-text">Representative Email <span class="text-danger">*</span></label>
                <input type="email" appInputLimit class="form-control rounded-pill shadow-none input-text"
                  placeholder="Type here" formControlName="representativeEmail"
                  [class.is-invalid]="contributorForm.get('company.representativeEmail')?.invalid && contributorForm.get('company.representativeEmail')?.touched" />
                <div class="invalid-feedback">
                  <div *ngIf="contributorForm.get('company.representativeEmail')?.errors?.['required']">
                    Representative email is required.
                  </div>
                  <div *ngIf="contributorForm.get('company.representativeEmail')?.errors?.['pattern']">
                    Please enter a valid email address.
                  </div>
                  <div *ngIf="contributorForm.get('company.representativeEmail')?.errors?.['maxlength']">
                    Email cannot exceed
                    {{contributorForm.get('company.representativeEmail')?.errors?.['maxlength'].requiredLength
                    }}characters.
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div class="form-group-fixed">
                <label class="label-text">Company Phone <span class="text-danger">*</span></label>
                <input type="text" appInputLimit class="form-control rounded-pill shadow-none input-text"
                  placeholder="Type here" formControlName="phone"
                  [class.is-invalid]="contributorForm.get('company.phone')?.invalid && contributorForm.get('company.phone')?.touched" />
                <div class="invalid-feedback">
                  <div *ngIf="contributorForm.get('company.phone')?.errors?.['required']">
                    Company phone is required.
                  </div>
                  <div *ngIf="contributorForm.get('company.phone')?.errors?.['pattern']">
                    Please enter a valid phone number.
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div class="form-group-fixed">
                <label class="label-text">Country <span class="text-danger">*</span></label>
                <input type="text" appInputLimit class="form-control rounded-pill shadow-none input-text"
                  placeholder="Type here" formControlName="country"
                  [class.is-invalid]="contributorForm.get('company.country')?.invalid && contributorForm.get('company.country')?.touched" />
                <div class="invalid-feedback">
                  <div *ngIf="contributorForm.get('company.country')?.errors?.['required']">
                    Country is required.
                  </div>
                  <div *ngIf="contributorForm.get('company.country')?.errors?.['maxlength']">
                    Country cannot exceed {{
                    contributorForm.get('company.country')?.errors?.['maxlength'].requiredLength}} characters.
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div class="form-group-fixed">
                <label class="label-text">City <span class="text-danger">*</span></label>
                <input type="text" appInputLimit class="form-control rounded-pill shadow-none input-text"
                  placeholder="Type here" formControlName="city"
                  [class.is-invalid]="contributorForm.get('company.city')?.invalid && contributorForm.get('company.city')?.touched" />
                <div class="invalid-feedback">
                  <div *ngIf="contributorForm.get('company.city')?.errors?.['required']">
                    City is required.
                  </div>
                  <div *ngIf="contributorForm.get('company.city')?.errors?.['maxlength']">
                    City cannot exceed {{ contributorForm.get('company.city')?.errors?.['maxlength'].requiredLength}}
                    characters.
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="form-group-fixed">
                <label class="label-text">Address <span class="text-danger">*</span></label>
                <input type="text" appInputLimit class="form-control rounded-pill shadow-none input-text"
                  placeholder="Type here" formControlName="address"
                  [class.is-invalid]="contributorForm.get('company.address')?.invalid && contributorForm.get('company.address')?.touched" />
                <div class="invalid-feedback">
                  <div *ngIf="contributorForm.get('company.address')?.errors?.['required']">
                    Address is required.
                  </div>
                  <div *ngIf="contributorForm.get('company.address')?.errors?.['maxlength']">
                    Address cannot exceed {{
                    contributorForm.get('company.address')?.errors?.['maxlength'].requiredLength}} characters.
                  </div>
                </div>
              </div>
            </div>
          </div>

          <h6 class="text-muted mt-4">Bank Account</h6>
          <hr class="my-3" />

          <div class="row g-3">
            <div class="col-12 col-lg-6">
              <div class="form-group-fixed">
                <label class="label-text">Account Holder Name <span class="text-danger">*</span></label>
                <input type="text" appInputLimit class="form-control rounded-pill shadow-none input-text"
                  placeholder="Type here" formControlName="accountHolderName"
                  [class.is-invalid]="contributorForm.get('company.accountHolderName')?.invalid && contributorForm.get('company.accountHolderName')?.touched" />
                <div class="invalid-feedback">
                  <div *ngIf="contributorForm.get('company.accountHolderName')?.errors?.['required']">
                    Account holder name is required.
                  </div>
                  <div *ngIf="contributorForm.get('company.accountHolderName')?.errors?.['pattern']">
                    Please enter a valid account holder name.
                  </div>
                  <div *ngIf="contributorForm.get('company.accountHolderName')?.errors?.['maxlength']">
                    Account holder name cannot exceed {{
                    contributorForm.get('company.accountHolderName')?.errors?.['maxlength'].requiredLength}} characters.
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-lg-6">
              <div class="form-group-fixed">
                <label class="label-text">Bank <span class="text-danger">*</span></label>

                <!-- Custom Searchable Dropdown -->
                <div class="searchable-dropdown"
                  [class.is-invalid]="contributorForm.get('company.bankId')?.invalid && contributorForm.get('company.bankId')?.touched"
                  [class.disabled]="!!contributorForm.get('company.bankId')?.disabled">

                  <!-- Hidden input to hold the actual bankId for Reactive Forms -->
                  <input type="hidden" formControlName="bankId">

                  <!-- Visible Search Input (NO formControlName here!) -->
                  <div class="dropdown-input-wrapper">
                    <input type="text" class="form-control shadow-none input-text" [value]="getSelectedBankName()"
                      (input)="onFilterBankSearchChange($event)" (focus)="openDropdown()" (blur)="onBlur()"
                      placeholder="Select a Bank" autocomplete="off"
                      [disabled]="contributorForm.get('company.bankId')?.disabled" #searchInput>
                    <span class="input-group-text"><i class="bi bi-chevron-down"></i></span>
                  </div>

                  <!-- Dropdown Options List -->
                  <div class="dropdown-list"
                    *ngIf="dropdownOpen && filteredBanks().length > 0 && !contributorForm.get('company.bankId')?.disabled">
                    <div class="dropdown-item" *ngFor="let bank of filteredBanks()" (mousedown)="selectBank(bank)"
                      [class.selected]="contributorForm.get('company.bankId')?.value === bank.bankId">
                      <span class="bank-name">{{ bank.bankName }}</span>
                    </div>
                  </div>

                  <!-- No Results Message -->
                  <div class="dropdown-list no-results"
                    *ngIf="dropdownOpen && filteredBanks().length === 0 && !contributorForm.get('company.bankId')?.disabled">
                    <div class="dropdown-item">No banks found</div>
                  </div>
                </div>

                <div class="invalid-feedback d-block"
                  *ngIf="contributorForm.get('company.bankId')?.invalid && contributorForm.get('company.bankId')?.touched">
                  <div *ngIf="contributorForm.get('company.bankId')?.errors?.['required']">
                    Bank is required.
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-lg-6">
              <div class="form-group-fixed">
                <label class="label-text">Account Number <span class="text-danger">*</span></label>
                <input type="text" appInputLimit class="form-control rounded-pill shadow-none input-text"
                  placeholder="Type here" formControlName="accountNumber"
                  [class.is-invalid]="contributorForm.get('company.accountNumber')?.invalid && contributorForm.get('company.accountNumber')?.touched" />
                <div class="invalid-feedback">
                  <div *ngIf="contributorForm.get('company.accountNumber')?.errors?.['required']">
                    Account number is required.
                  </div>
                  <div *ngIf="contributorForm.get('company.accountNumber')?.errors?.['pattern']">
                    Please enter a valid account number.
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div class="form-group-fixed">
                <label class="label-text">Contribution Amount <span class="text-danger">*</span></label>
                <app-formatted-number-input [min]="0" [max]="999999999999.99"
                  formControlName="contributionAmount" [isInvalid]="!!(contributorForm.get('company.contributionAmount')?.invalid &&
                                                  contributorForm.get('company.contributionAmount')?.touched)"
                  class="formatted-input-control" />
                <!-- <input type="number" min="0" max="999999999999.99" step="0.01" appInputLimit class="form-control rounded-pill shadow-none input-text"
                  placeholder="Type here" formControlName="contributionAmount"
                  [class.is-invalid]="contributorForm.get('company.contributionAmount')?.invalid && contributorForm.get('company.contributionAmount')?.touched" /> -->
                <div class="invalid-feedback d-block"
                  *ngIf="contributorForm.get('company.contributionAmount')?.invalid && contributorForm.get('company.contributionAmount')?.touched">

                  <div *ngIf="contributorForm.get('company.contributionAmount')?.errors?.['required']">
                    Contribution amount is required.
                  </div>

                  <div *ngIf="contributorForm.get('company.contributionAmount')?.errors?.['min']">
                    Contribution amount cannot be negative.
                  </div>
                  <div *ngIf="contributorForm.get('company.contributionAmount')?.errors?.['max']">
                    Contribution amount cannot exceed the maximum limit - 999999999999.99.
                  </div>
                </div>

              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div class="form-group-fixed">
                <label class="label-text">Currency <span class="text-danger">*</span></label>
                <div class="input-group">
                  <select class="form-control shadow-none input-text select-with-icon" formControlName="currency"
                    [class.is-invalid]="contributorForm.get('company.currency')?.invalid && contributorForm.get('company.currency')?.touched">
                    <option [ngValue]="null" disabled>Select a Currency</option>
                    <option *ngFor="let currency of currencies()" [ngValue]="currency.currencyId">
                      {{ currency.isoCode }} - {{ currency.name }}
                    </option>
                  </select>
                  <span class="input-group-text"><i class="bi bi-chevron-down"></i></span>
                </div>
                <div class="invalid-feedback d-block"
                  *ngIf="contributorForm.get('company.currency')?.invalid && contributorForm.get('company.currency')?.touched">
                  <div *ngIf="contributorForm.get('company.currency')?.errors?.['required']">
                    Currency is required.
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div class="form-group-fixed">
                <label class="label-text">Cost of Fund <span class="text-danger">*</span></label>
                <div class="input-group">
                  <input type="number" appInputLimit min="0" max="100" step="0.01"
                    class="form-control cost-of-fund shadow-none input-text" placeholder="Type here"
                    formControlName="costOfFund"
                    [class.is-invalid]="contributorForm.get('company.costOfFund')?.invalid && contributorForm.get('company.costOfFund')?.touched" />
                  <span class="input-group-text">%</span>
                </div>
                <div class="invalid-feedback d-block"
                  *ngIf="contributorForm.get('company.costOfFund')?.invalid && contributorForm.get('company.costOfFund')?.touched">

                  <div *ngIf="contributorForm.get('company.costOfFund')?.errors?.['required']">
                    Cost of fund is required.
                  </div>

                  <div
                    *ngIf="contributorForm.get('company.costOfFund')?.errors?.['min'] || contributorForm.get('company.costOfFund')?.errors?.['max']">
                    Cost of fund must be between 0 and 100.
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
        }
      </div>

      <div class="d-flex justify-content-end gap-2 mt-4" *ngIf="mode() === 'view'">
        <button type="button" class="btn btn-primary" (click)="openEditContributorForm()"
          *ngIf="authService.canEdit('fundManagement.contributorManagement')">
          <i class="bi bi-pencil-square me-2"></i>
          Edit
        </button>
      </div>

      <div class="d-flex justify-content-end gap-2 mt-4" *ngIf="mode() === 'add' || mode() === 'edit'">
        <button type="button" class="btn btn-secondary" (click)="cancelEdit()" *ngIf="mode() === 'edit'">
          <i class="bi bi-x-circle me-2"></i>
          Cancel
        </button>
        <!-- <button type="button" class="btn btn-outline-secondary" (click)="clearForm()">
          <i class="bi bi-eraser me-2"></i>
          Clear
        </button> -->
        <button type="button" class="btn btn-success" [disabled]="isSubmitDisabled || !contributorForm.valid"
          (click)="submitContributor()" *ngIf="authService.canReview('fundManagement.contributorManagement')">
          <i class="bi bi-save me-2"></i>
          {{ mode() === 'edit' ? 'Update' : 'Submit' }}
        </button>
      </div>
    </form>
  </div>

  <!-- Confirmation Modal -->
  <div class="modal fade" id="contributorTypeChangeModal" tabindex="-1"
    aria-labelledby="contributorTypeChangeModalLabel" aria-hidden="true" data-bs-backdrop="false">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content border-0 shadow-lg">
        <!-- Warning Icon Header -->
        <div class="text-center pt-4 pb-2">
          <div class="warning-icon-wrapper mx-auto mb-3">
            <i class="bi bi-exclamation-triangle-fill text-warning"></i>
          </div>
          <h5 class="modal-title fw-bold mb-0" id="contributorTypeChangeModalLabel">
            Confirm Contributor Type Change
          </h5>
        </div>

        <!-- Modal Body -->
        <div class="modal-body text-center px-4 py-3">
          <p class="text-muted mb-0">
            {{ confirmationMessage }}
          </p>
        </div>

        <!-- Modal Footer -->
        <div class="modal-footer border-0 justify-content-center gap-2 pb-4">
          <button type="button" class="btn btn-outline-secondary px-4" (click)="onCancelTypeChange()">
            No, Keep & Change
          </button>
          <button type="button" class="btn btn-primary px-4" (click)="onConfirmTypeChange()">
            Yes, Change Type
          </button>
        </div>
      </div>
    </div>
  </div>

</div>